// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"be954fa8","40":"28e2b935","130":"80a81d80","203":"6a520a3a","403":"23c924e4","405":"011e5d9c","488":"e7e55690","556":"285a70cd","635":"22bd9a88","653":"69f781c4","791":"b1c88dcb","845":"59835356","888":"9e35d0e2","940":"2b8d71e7"}[chunkId] + ".chunk.js";
};